<template lang="html">
  <div id="neighbourhood-heart" class="contained-height w-100">
    <div class="neighbourhood-content d-flex align-items-center justify-content-center">
      <img
        class="builder-img position-absolute"
        v-for="(img, imgIndex) in architecture"
        :class="{ active: imgIndex == index }"
        :src="assetsUrl + img.url"
        :key="img"
      />
      <div class="neighbourhood-arrows position-absolute d-flex flex-row align-items-center justify-content-end">
        <div class="index pr-4">
          {{ index + 1 }} / {{ architecture.length || 0}}
        </div>
        <div class="arrow-container d-flex flex-row align-items-center justify-content-end">
          <div class="neighbourhood-arr d-flex flex-row align-items-center justify-content-center" @click="prevSlide()">
            <i class="fal fa-long-arrow-left"></i>
          </div>
          <div class="neighbourhood-arr d-flex flex-row align-items-center justify-content-center" @click="nextSlide()">
            <i class="fal fa-long-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapGetters } from 'vuex';

export default {
  name: 'neighbourhood-heart',
  data() {
    return {
      index: 0
    };
  },
  computed: {
    ...mapState({
      assetsUrl: state => state.project.assetsUrl,
      architecture: state => state.neighbourhood.architecture
    }),
    ...mapGetters({
      deviceLg: 'ui/deviceLg'
    })
  },
  methods: {
    ...mapMutations({
      setPageReady: 'ui/setPageReady'
    }),
    prevSlide() {
      this.index -= 1;
      if (this.index < 0) {
        this.index = this.architecture.length - 1;
      }
    },
    nextSlide() {
      this.index += 1;
      if (this.index === this.architecture.length) {
        this.index = 0;
      }
    }
  },
  mounted() {
    this.setPageReady(true);
  },
  watch: {},
  components: {}
};
</script>

<style lang="scss" scoped>
#neighbourhood-heart {
  .neighbourhood-content {
    width: calc(1920px - #{$neighbourhoodNavWidth});
    margin-left: auto;
    // background-color: black;
    height: 100%;
  }

  .builder-img {
    transition: all 0.5s ease-out;
    opacity: 0;
    transition-delay: 0s;
    transform: translate3d(0px, 50px, 0px);

    &.active {
      opacity: 1;
      transition-delay: 0s;
      transform: translate3d(0px, 0px, 0px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/NeighbourhoodPage/NeighbourhoodHeart/NeighbourhoodHeart.vue